import { useState } from 'react'
import { DownloadCloud, Search, SlidersHorizontal } from 'lucide-react'
import {
  Checkbox,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@wove/web-ui'
// import { FileExportDialog } from '../FileExportDialog'
import { BatchExportDialog } from '../BatchExportDialog'
import { useGetSourcesQuery } from '@wove/api'
import { FileRow } from './FileRow'

export function FileTable() {
  const [queryData] = useGetSourcesQuery()
  const [searchQuery, setSearchQuery] = useState('')
  const files = queryData?.data?.getSources?.slice(0, 3) || []
  // const [files, setFiles] = useState<FileData[]>(demoFiles)

  // Add these state variables inside the FileTable component
  const [selectedFileIds, setSelectedFileIds] = useState<string[]>([])
  const [batchExportDialogOpen, setBatchExportDialogOpen] = useState(false)

  // Add the error dialog state and functions
  // const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  // const [selectedErrorFile, setSelectedErrorFile] = useState<FileData | null>(null)

  // // Add a function to handle showing error details
  // const showErrorDetails = (file: FileData) => {
  //   setSelectedErrorFile(file)
  //   setErrorDialogOpen(true)
  // }

  // // Add a function to retry processing a file
  // const retryProcessing = (fileId: string) => {
  //   // In a real app, this would trigger reprocessing on the server
  //   // For demo, we'll just simulate success after a delay
  //   setFiles((prev) =>
  //     prev.map((file) => {
  //       if (file.id === fileId) {
  //         return {
  //           ...file,
  //           status: 'success',
  //           errorDetails: undefined,
  //           errorCode: undefined,
  //         }
  //       }
  //       return file
  //     }),
  //   )
  // }

  // // Simulate a new file being added to demonstrate animation
  // const addNewFile = () => {
  //   const newFile = {
  //     id: Math.random().toString(36).substring(2, 9),
  //     name: 'New_Shipping_Rates_' + new Date().toISOString().slice(0, 10) + '.xlsx',
  //     rates: 'FCL',
  //     type: 'xlsx',
  //     tags: ['New', 'Import'],
  //     size: '1.2 Mb',
  //     uploaded: 'Just now',
  //     isNew: true,
  //   }

  //   setFiles((prev) => [newFile, ...prev])

  //   // Remove the "new" flag after animation completes
  //   setTimeout(() => {
  //     setFiles((prev) =>
  //       prev.map((file) => {
  //         if (file.id === newFile.id) {
  //           return { ...file, isNew: false }
  //         }
  //         return file
  //       }),
  //     )
  //   }, 1000)
  // }

  const filteredFiles = files.filter(
    (file) =>
      file.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      file.tags.some((tag) => tag.name.toLowerCase().includes(searchQuery.toLowerCase())),
  )

  // const [exportDialogOpen, setExportDialogOpen] = useState(false)
  // const [selectedFile, setSelectedFile] = useState<FileData | null>(null)

  // Add this function inside the FileTable component
  const toggleFileSelection = (id: string) => {
    console.log('Stuff:', id)
    setSelectedFileIds((prev) =>
      prev.includes(id) ? prev.filter((fileId) => fileId !== id) : [...prev, id],
    )
  }

  const selectAllFiles = (checked: boolean) => {
    if (checked) {
      setSelectedFileIds(filteredFiles.map((file) => file.id))
    } else {
      setSelectedFileIds([])
    }
  }

  // const handleExport = (id: string, type: string) => {
  //   const file = files.find((f) => f.id === id)
  //   if (file) {
  //     setSelectedFile(file)
  //     setExportDialogOpen(true)
  //   }
  // }

  // const handleViewDetails = (id: string) => {
  //   // In a real app, this would navigate to a details page or open a details modal
  //   console.log(`View details for file ${id}`)
  // }

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Recent Files</CardTitle>
        <div className="flex items-center gap-2">
          {selectedFileIds.length > 0 && (
            <Button
              variant="outline"
              onClick={() => setBatchExportDialogOpen(true)}
              className="mr-2 whitespace-nowrap text-xs sm:text-sm"
              size="sm"
            >
              <DownloadCloud className="mr-1 h-3.5 w-3.5 sm:mr-2 sm:h-4 sm:w-4" />
              <span className="hidden sm:inline">Export</span> ({selectedFileIds.length})
            </Button>
          )}
          <div className="relative">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search files..."
              className="w-[120px] pl-8 sm:w-[200px] md:w-[300px]"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <Button variant="outline" size="icon">
            <SlidersHorizontal className="h-4 w-4" />
            <span className="sr-only">Filter</span>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-[50px]">
                  <Checkbox
                    checked={
                      filteredFiles.length > 0 && selectedFileIds.length === filteredFiles.length
                    }
                    onChange={(e) => {
                      selectAllFiles(e.target.checked)
                    }}
                    aria-label="Select all files"
                  />
                </TableHead>
                <TableHead className="w-[400px]">Name</TableHead>
                <TableHead>Rates</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Tags</TableHead>
                <TableHead>Size</TableHead>
                <TableHead>Uploaded</TableHead>
                <TableHead className="w-[50px]"></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filteredFiles.map((file) => (
                <FileRow
                  onFileSelected={toggleFileSelection}
                  isSelected={selectedFileIds.includes(file.id)}
                  file={file}
                  key={file.id}
                />
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
      {/* {selectedFile && (
        <FileExportDialog
          isOpen={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          fileName={selectedFile.name}
          fileType={selectedFile.type}
        />
      )} */}
      {selectedFileIds.length > 0 && (
        <BatchExportDialog
          isOpen={batchExportDialogOpen}
          onClose={() => setBatchExportDialogOpen(false)}
          selectedFileIds={selectedFileIds}
        />
      )}
      {/* Error Details Dialog
      <Dialog open={errorDialogOpen} onOpenChange={setErrorDialogOpen}>
        <DialogContent className="sm:max-w-[500px] max-w-[95vw] p-8 bg-white">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {selectedErrorFile?.status === 'error' ? (
                <>
                  <AlertCircle className="h-5 w-5 text-red-500" />
                  <span>Error Details</span>
                </>
              ) : (
                <>
                  <AlertTriangle className="h-5 w-5 text-amber-500" />
                  <span>Warning Details</span>
                </>
              )}
            </DialogTitle>
            <DialogDescription>{selectedErrorFile?.name}</DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <h4 className="text-sm font-medium">Error Code:</h4>
                <code className="bg-muted px-1 py-0.5 rounded text-xs">
                  {selectedErrorFile?.errorCode || 'UNKNOWN_ERROR'}
                </code>
              </div>

              <div className="space-y-1">
                <h4 className="text-sm font-medium">Description:</h4>
                <p className="text-sm text-muted-foreground">
                  {selectedErrorFile?.errorDetails || 'No additional details available.'}
                </p>
              </div>

              <div className="space-y-1 mt-4">
                <h4 className="text-sm font-medium">Recommended Actions:</h4>
                <div className="bg-muted p-3 rounded-md">
                  <ul className="text-sm space-y-2 list-disc pl-5">
                    {selectedErrorFile?.errorCode === 'ERR_FORMAT_INCONSISTENT' && (
                      <>
                        <li>
                          Review the file to ensure all rate tables follow a consistent format
                        </li>
                        <li>Check for mixed units or currency formats across different tables</li>
                        <li>
                          Consider splitting the file into multiple files with consistent formats
                        </li>
                      </>
                    )}
                    {selectedErrorFile?.errorCode === 'WARN_PARTIAL_EXTRACTION' && (
                      <>
                        <li>Upload a higher quality version of the PDF if available</li>
                        <li>Check if the PDF contains scanned images rather than text</li>
                        <li>Review the extracted data for accuracy and completeness</li>
                      </>
                    )}
                    {selectedErrorFile?.errorCode === 'ERR_FILE_PROTECTED' && (
                      <>
                        <li>Remove password protection from the file</li>
                        <li>Check if the file has editing restrictions enabled</li>
                        <li>Save a copy of the file without protection and upload again</li>
                      </>
                    )}
                    {!selectedErrorFile?.errorCode && (
                      <li>Try uploading the file again or contact support for assistance</li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <DialogFooter className="flex-col sm:flex-row gap-2">
            <Button variant="outline" onClick={() => setErrorDialogOpen(false)}>
              Close
            </Button>
            <Button
              onClick={() => {
                if (selectedErrorFile) {
                  retryProcessing(selectedErrorFile.id)
                  setErrorDialogOpen(false)
                }
              }}
            >
              <RefreshCcw className="mr-2 h-4 w-4" />
              Retry Processing
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
    </Card>
  )
}
